// extracted by mini-css-extract-plugin
export default {"message":"aJeiGas7bM3k9smf","box":"Ac3v6ladcbMX4Qyd","grow-wrap":"KIkdsSnCw6Q1LoEw","growWrap":"KIkdsSnCw6Q1LoEw"};